import {
    ComponentSegmentRelationAnchor,
    ComponentSegmentRelationVersion,
} from 'src/models/anchor-and-version/component-segment-relation.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AnchorAndVersionBaseService } from './anchor-and-version-base.service';
import { AuthService } from '../auth.service';
import { ComponentAnchor } from 'src/models/anchor-and-version/component.model';
import { ComponentSegmentRelationFilter } from 'src/filters/anchor-and-version-filter/component-segment-relation.filter';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { SegmentAnchor } from 'src/models/anchor-and-version/segment.model';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

export interface ComponentSegmentRelationGroup {
    component: ComponentAnchor;
    segments: SegmentAnchor[];
}

@Injectable({ providedIn: 'root' })
export class ComponentSegmentRelationService extends AnchorAndVersionBaseService<
    ComponentSegmentRelationAnchor,
    ComponentSegmentRelationVersion
> {
    protected authService = inject(AuthService);
    protected baseUrl = '/api/componentsegmentrelation';
    protected http = inject(HttpClient);
    protected store = inject<Store<{ config: ConfigState }>>(Store);

    public async getAllComponentSegmentRelations(
        searchString?: string
    ): Promise<ComponentSegmentRelationGroup[]> {
        const params = await this.getComponentSegmentRelationParams(searchString);

        return firstValueFrom(
            this.http.get<ComponentSegmentRelationGroup[]>(
                this.baseUrl + '/get-all-csr-with-children',
                {
                    headers: await this.createHeaders(),
                    params: params,
                }
            )
        );
    }

    public async getByComponent(
        componentAnchorKey: number
    ): Promise<ComponentSegmentRelationAnchor[]> {
        const filter: ComponentSegmentRelationFilter = { aComponentAnchorKey: componentAnchorKey };
        return this.getAnchorsWithValidVersion(filter);
    }

    public async getComponentSegmentRelation(
        searchString?: string,
        limit?: number,
        offset?: number
    ): Promise<ComponentSegmentRelationGroup[]> {
        let params = await this.getComponentSegmentRelationParams(searchString);
        if (offset) {
            params = params.append('offset', offset);
        }
        if (limit) {
            params = params.append('limit', limit);
        }
        return firstValueFrom(
            this.http.get<ComponentSegmentRelationGroup[]>(
                this.baseUrl + '/get-csr-with-children',
                {
                    headers: await this.createHeaders(),
                    params: params,
                }
            )
        );
    }

    private async getComponentSegmentRelationParams(searchString?: string): Promise<HttpParams> {
        let params = new HttpParams()
            .append('sop', await this.getSop())
            .append('workspace', await this.getWorkspaceKey());
        if (searchString) {
            params = params.append('searchString', searchString);
        }

        return params;
    }
}
